import React from "react"
import PropTypes from "prop-types"

import { withStyles } from "@material-ui/core/styles"
import classnames from "classnames"

export const styleSheet = _theme => ({
  root: {
    flex: [0, 0, "auto"],
    position: "relative",
  },
})

export class ScrollFrameHeader extends React.PureComponent {
  static propTypes = {
    classes: PropTypes.object,
    scrolled: PropTypes.bool,
  }

  render() {
    const {
      classes,
      className: classNameProp,
      scrolled,

      ...otherProps
    } = this.props

    const className = classnames(
      classes.root,
      {
        [classes.scrolled]: scrolled,
      },
      classNameProp
    )

    return <div {...otherProps} className={className} />
  }
}

export default withStyles(styleSheet)(ScrollFrameHeader)



// WEBPACK FOOTER //
// ../ui-kit/src/components/ui-ScrollFrame/ScrollFrameHeader.js